import { useState as h, useCallback as l, useRef as S, useEffect as w, useLayoutEffect as y } from "react";
function L(e) {
  const [t, n] = h(!!e), s = l(() => n(!0), []), c = l(() => n(!1), []), r = l(() => n((i) => !i), []);
  return { value: t, setValue: n, setTrue: s, setFalse: c, toggle: r };
}
globalThis && globalThis.__awaiter;
function $(e) {
  let t = !1, n, s, c, r;
  "seconds" in e ? (console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3."), t = !0, n = e.seconds, s = e.interval, c = e.isIncrement) : { countStart: n, intervalMs: s, isIncrement: c, countStop: r } = e, s = s ?? 1e3, c = c ?? !1, r = r ?? 0;
  const { count: i, increment: o, decrement: u, reset: f } = I(n), { value: a, setTrue: d, setFalse: g } = L(!1), v = () => {
    g(), f();
  }, C = l(() => {
    if (i === r) {
      g();
      return;
    }
    c ? o() : u();
  }, [i, r, u, o, c, g]);
  return T(C, a ? s : null), t ? [
    i,
    {
      start: d,
      stop: g,
      reset: v
    }
  ] : [
    i,
    {
      startCountdown: d,
      stopCountdown: g,
      resetCountdown: v
    }
  ];
}
function I(e) {
  const [t, n] = h(e || 0);
  return {
    count: t,
    increment: () => n((i) => i + 1),
    decrement: () => n((i) => i - 1),
    reset: () => n(e || 0),
    setCount: n
  };
}
function E(e) {
  const t = S(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return p(() => {
    t.current = e;
  }, [e]), l((...n) => t.current(...n), [t]);
}
function m(e, t, n, s) {
  const c = S(t);
  p(() => {
    c.current = t;
  }, [t]), w(() => {
    var r;
    const i = (r = n == null ? void 0 : n.current) !== null && r !== void 0 ? r : window;
    if (!(i && i.addEventListener))
      return;
    const o = (u) => c.current(u);
    return i.addEventListener(e, o, s), () => {
      i.removeEventListener(e, o, s);
    };
  }, [e, n, s]);
}
globalThis && globalThis.__awaiter;
function T(e, t) {
  const n = S(e);
  p(() => {
    n.current = e;
  }, [e]), w(() => {
    if (!t && t !== 0)
      return;
    const s = setInterval(() => n.current(), t);
    return () => clearInterval(s);
  }, [t]);
}
function b() {
  const e = S(!0);
  return e.current ? (e.current = !1, !0) : e.current;
}
const p = typeof window < "u" ? y : w;
function J(e, t) {
  const n = l(() => {
    if (typeof window > "u")
      return t;
    try {
      const o = window.localStorage.getItem(e);
      return o ? F(o) : t;
    } catch (o) {
      return console.warn(`Error reading localStorage key “${e}”:`, o), t;
    }
  }, [t, e]), [s, c] = h(n), r = E((o) => {
    typeof window > "u" && console.warn(`Tried setting localStorage key “${e}” even though environment is not a client`);
    try {
      const u = o instanceof Function ? o(s) : o;
      window.localStorage.setItem(e, JSON.stringify(u)), c(u), window.dispatchEvent(new Event("local-storage"));
    } catch (u) {
      console.warn(`Error setting localStorage key “${e}”:`, u);
    }
  });
  w(() => {
    c(n());
  }, []);
  const i = l((o) => {
    o != null && o.key && o.key !== e || c(n());
  }, [e, n]);
  return m("storage", i), m("local-storage", i), [s, r];
}
function F(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
function x(e) {
  const t = (r) => typeof window < "u" ? window.matchMedia(r).matches : !1, [n, s] = h(t(e));
  function c() {
    s(t(e));
  }
  return w(() => {
    const r = window.matchMedia(e);
    return c(), r.addListener ? r.addListener(c) : r.addEventListener("change", c), () => {
      r.removeListener ? r.removeListener(c) : r.removeEventListener("change", c);
    };
  }, [e]), n;
}
function N(e, t) {
  const n = l(() => {
    if (typeof window > "u")
      return t;
    try {
      const o = window.sessionStorage.getItem(e);
      return o ? M(o) : t;
    } catch (o) {
      return console.warn(`Error reading sessionStorage key “${e}”:`, o), t;
    }
  }, [t, e]), [s, c] = h(n), r = E((o) => {
    typeof window > "u" && console.warn(`Tried setting sessionStorage key “${e}” even though environment is not a client`);
    try {
      const u = o instanceof Function ? o(s) : o;
      window.sessionStorage.setItem(e, JSON.stringify(u)), c(u), window.dispatchEvent(new Event("session-storage"));
    } catch (u) {
      console.warn(`Error setting sessionStorage key “${e}”:`, u);
    }
  });
  w(() => {
    c(n());
  }, []);
  const i = l((o) => {
    o != null && o.key && o.key !== e || c(n());
  }, [e, n]);
  return m("storage", i), m("session-storage", i), [s, r];
}
function M(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
function R(e, t) {
  const n = b();
  w(() => {
    if (!n)
      return e();
  }, t);
}
export {
  m as a,
  $ as b,
  E as c,
  p as d,
  x as e,
  R as f,
  N as g,
  J as u
};
